import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";
import shadows from "styles/shadows";

export const IrisProsList = styled.ul`
  list-style: none;
  flex: 2;
  margin-top: 1em;

  && {
    margin-left: 0;
  }

  li {
    display: flex;
    align-items: center;
    padding: 0.5em 0.8em;
    font-weight: 900;
    border-left: 1px solid ${colours.elexonCheckGreen};
    box-shadow: ${shadows.shadowMd};
    color: ${colours.elexonBlack};
    span.icon {
      margin-right: 8px;
      margin-top: 1px;
    }
  }
`;

export const DescriptionHeader = styled.p`
  && {
    font-weight: ${fonts.heavy};
    color: ${colours.elexonBlack};
    font-size: 1.5em;
  }
`;

export const Description = styled.p`
  font-size: 1em;
  font-weight: 400;
  color: ${colours.elexonBlack};
`;

export const Column = styled.div`
  column-gap: 1em;
`;
